export default "__VITE_PUBLIC_ASSET__54c5bd74__"